import styles from './styles.module.scss';

import cn from 'classnames';

const SendButton = ({
  multiple = false,
  width = 'default',
  height = '36px',
  style,
  url,
  data = {},
  redButton = false,
  children,
  disabled = false,
  sendData = {},
  sendApi = async () => { },
  endLoad = async () => { },
  ...props
}) => {




  const onLoad = async (event) => {

    const files = event.target.files
    await sendApi({ ...sendData, data: { ...sendData.data, files: Array.from(files), fileNames: Array.from(files).map(f => f.name), ...(!multiple && { oneFile_: true }) }, options: { ...sendData.options, uploadFiles: true } })
      .then(r => endLoad({}))
      .finally(() => {
        event.target.value = null;
      })
  }

  return (
    <label className={cn(disabled && styles.disabled)} style={{ width, height, ...style }}>
      <span className={cn(disabled && styles.disabled, styles.button_base, styles.button_green, redButton && styles.button_red, props.styles)}>
        {children}
      </span>
      {/* <input type="file" className={styles.input} onChange={onLoad} {...(multiple && multiple)} /> */}

      {multiple ?
        <input type="file" className={styles.input} onChange={onLoad} multiple />
        :
        <input type="file" className={styles.input} onChange={onLoad} />
      }
    </label>
  );
};

export default SendButton;
